import { TmBaseError } from '@/core/error/tmBaseError'

export class TmNotResolvedAsyncStrategyError extends TmBaseError {
  public name = 'TmNotResolvedAsyncStrategyError'

  constructor(strategy: string) {
    super(`Not resolved async strategy "${strategy}"`)
  }
}
